import {
  LookupItemDto
} from '@paladin-monorepo/common';
import API from '../api';

export const codebookApi = {
  async listCategories(): Promise<LookupItemDto[]> {
    return API.get<LookupItemDto[]>(`/codebook/categories`).then((res) => res.data);
  },

  async listIndustries(): Promise<LookupItemDto[]> {
    return API.get<LookupItemDto[]>(`/codebook/industries`).then((res) => res.data);
  },

  async listDeliverables(category?: string, locale?: string): Promise<LookupItemDto[]> {
    const params = new URLSearchParams();
    if (category) params.set('category', category);
    if (locale) params.set('locale', locale);
    const qs = params.toString() ? `?${params.toString()}` : '';
    return API.get<LookupItemDto[]>(`/codebook/deliverables${qs}`).then((res) => res.data);
  },

  async listExpertise(): Promise<LookupItemDto[]> {
    return API.get<LookupItemDto[]>(`/codebook/expertises`).then((res) => res.data);
  },

  async listSkills(search?: string): Promise<LookupItemDto[]> {
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    const qs = params.toString() ? `?${params.toString()}` : '';
    return API.get<LookupItemDto[]>(`/codebook/skills${qs}`).then((res) => res.data);
  },
};
